import React from 'react'
import './Navigation.scss'
//@ts-ignore
import logo from '../../assets/logo.png'
import { Link } from 'react-router-dom'
import { Avatar, Menu, MenuItem } from '@mui/material'

interface NavigationPropTypes {
    isDark?: boolean;
    hasUser?: boolean;
}

const Navigation = ({ isDark = true, hasUser = false }: NavigationPropTypes) => {

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        console.log("ran")
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <nav>
                <Link to={'/'}>
                    <img className="navLogo" src={logo} alt={"logo"} />
                </Link>
                {hasUser ?
                    <>
                        <div
                            className="navProfile"
                            onClick={handleMenu}
                        >
                            <Avatar
                                sx={{ bgcolor: "#669260" }}
                            >
                                J
                            </Avatar>
                            <div>
                                <p>Josef Smith</p>
                                <p><span className="navEmail">josef_s@gmail.com</span></p>
                            </div>
                        </div>
                        <Menu

                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'center',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <MenuItem onClick={() => { }}>Profile</MenuItem>
                            <MenuItem onClick={() => { }}>Logout</MenuItem>
                        </Menu>
                    </>
                    :
                    null
                }

            </nav>
            <div style={{ height: "110px" }}></div>
        </>
    )
}

Navigation.propTypes = {}

export default Navigation